export default [ 'shift-report', 'welcome-screen', 'order-detail' ]